import { render, staticRenderFns } from "./parcelasVencidasRegularizadas.vue?vue&type=template&id=fbd5d5c8"
import script from "./parcelasVencidasRegularizadas.vue?vue&type=script&lang=js"
export * from "./parcelasVencidasRegularizadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports